import { sagas as feedbackSagas } from './modules/feedback'

export default [...feedbackSagas]
